import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { getUserType, objectToFormData, paymentColor } from 'utils/helpers';
import { fetchEventAbstractsData, handlePassRegenerate } from 'store/slices';
import Card from 'components/Layout/Card';
import Table from 'components/Layout/Table';
import Button from 'components/form/Button';
import SeachInput from 'components/form/SeachInput';
import { limit } from 'utils/constants';
import './ClientConferenceTickets.scss';

const ClientConferenceTickets = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams();
  const { eventId } = params;
  const userType = getUserType();
  const [activeTab, setActiveTab] = useState('all');
  const [abstractData, setAbstractData] = useState([]);
  const [abstractEventName, setAbstractEventName] = useState('');
  const [searchPayload, setSearchPayload] = useState({
    email_id: '',
    member_id: '',
    phone_number: '',
  });
  const [filterData, setFilterData] = useState({
    total: 0,
    offset: 0,
    limit: limit,
    event_id: eventId,
  });
  const [isLoading, setIsLoading] = useState(true);
  const [globalSearchVal, setGlobalSearchVal] = useState('');
  const [timer, setTimer] = useState('');
  const [btnLoading, setBtnLoading] = useState(false);

  
  const tabs = [
    { label: 'All', value: 'all' },
    { label: 'Paid', value: 'paid' },
    { label: 'UnPaid', value: 'unpaid' },
    { label: 'Pending Verification', value: 'under verification' },
  ];

  const { userDetails } = useSelector((state) => ({
    userDetails: state.student.userDetails,
  }));

  const { view: viewAccess, create: createAccess } =
    userDetails?.role_data?.find(
      (item) => item?.permission_name === 'Instant Ticket Generate'
    )?.sub_permission || {};

  const getEventAbstarcts = async (obj) => {
    let forData = objectToFormData(obj);
    const response = await dispatch(fetchEventAbstractsData(forData));
    setAbstractEventName(response?.data?.event_name || '');
    setAbstractData(response?.data?.abstract_data || []);
    setFilterData({
      ...obj,
      total: response?.data?.result_count || 0,
    });
    setIsLoading(false);
  };

  const handelChangeSearch = (searchData) => {
    setIsLoading(true);
    let newData = filterData;
    setSearchPayload(searchData);
    newData = { ...newData, ...searchData, offset: 0, status: activeTab };
    setFilterData(newData);
    getEventAbstarcts(newData);
  };
  const handelChangePagination = (offset) => {
    setIsLoading(true);
    let newData = { ...filterData, ...searchPayload, status: activeTab };
    newData = { ...newData, offset: offset };
    setFilterData(newData);
    getEventAbstarcts(newData);
  };

  const handleGlobalSearch = (e) => {
    setGlobalSearchVal(e.target.value);
    let time = timer;
    clearTimeout(time);
    time = setTimeout(() => {
      let newData = { ...filterData, ...searchPayload, status: activeTab };
      newData = { ...newData, global_filter: e.target.value, offset: 0 };
      setIsLoading(true);
      setFilterData(newData);
      getEventAbstarcts(newData);
    }, 800);
    setTimer(time);
  };

  useEffect(() => {
    getEventAbstarcts({ ...filterData, ...searchPayload });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleRegenerate = async (abstract_id) => {
    setBtnLoading((prev) => ({ ...prev, [abstract_id]: true }));
    const payload = {
      type: 'author',
      id: abstract_id,
    };
    const response = await dispatch(handlePassRegenerate(payload));
    if (response.status === 200) {
      navigate(
        `/${userType}/instant-ticket-generate/${eventId}/client-conference-tickets/${abstract_id}/view`
      );
    }
    setBtnLoading((prev) => ({ ...prev, [abstract_id]: false }));
  };


  useEffect(() => {
    let newData = filterData;
    newData = { ...newData, ...searchPayload, offset: 0, status: activeTab };
    getEventAbstarcts(newData);
  }, [activeTab]);

  const header = [
    {
      isSearch: true,
      searchInputName: 'author_name',
      title: 'Author',
    },
    {
      isSearch: true,
      searchInputName: 'member_id',
      title: 'Member ID',
    },
    {
      isSearch: true,
      searchInputName: 'author_email',
      title: 'Email Id',
    },

    {
      isSearch: true,
      searchInputName: 'phone_no',
      title: 'Phone Number',
    },
    {
      isSearch: true,
      searchInputName: 'membership_plan',
      title: 'Member Type',
    },

    {
      isSearch: true,
      searchInputName: 'paperId',
      title: 'Paper ID',
    },

    {
      isSearch: true,
      searchInputName: 'paperTitle',
      title: 'Paper Title',
    },
    {
      isSearch: true,
      searchInputName: 'payment_status',
      title: 'Payment',
    },

    {
      isSearch: true,
      searchInputName: 'download_status',
      title: 'Download Status',
    },
    {
      isSearch: false,
      // searchLable: "View/Edit/Delete",
      title: 'Action',
    },
  ];

  const rowData = [];
  abstractData?.forEach((elem, index) => {
    const {
      author_name,
      member_id,
      author_email,
      phone_no,
      membership_plan,
      paperTitle,
      paperId,
      payment_status,
      download_status,
      abstract_id,
    } = elem;

    let obj = [
      {
        value: `${author_name}`,
      },
      {
        value: member_id,
      },
      {
        value: author_email,
      },
      {
        value: phone_no,
      },
      {
        value: membership_plan ? membership_plan : '-',
      },
      {
        value: paperId,
      },
      {
        value: paperTitle,
      },

      {
        value: (
          <div className={paymentColor(payment_status)}>
            {payment_status ? payment_status : '-'}
          </div>
        ),
      },
      {
        value: download_status,
      },
      {
        value: (
          <>
            {viewAccess === '1' && (
              <Button
                btnStyle="primary-light-outline"
                className="h-35 text-14-500 w-100 cmb-10 cps-20 cpe-20"
                text="View"
                onClick={() =>
                  navigate(
                    `/${userType}/instant-ticket-generate/${eventId}/client-conference-tickets/${abstract_id}/view`
                  )
                }
              />
            )}

            {payment_status === 'Paid' && createAccess === '1' && (
              <Button
                btnStyle="primary-outline1"
                className="h-35 text-14-500 w-100"
                text="ReGenerate"
                onClick={() => handleRegenerate(abstract_id)}
                disabled={btnLoading[abstract_id]}
                btnLoading={btnLoading[abstract_id]}
              />
            )}
          </>
        ),
      },
    ];
    rowData.push({ data: obj });
  });

  return (
    <div id="client-conference-tickets-container">
      <Card className="cmt-20">
        <div className="client-conference-tickets-tab d-flex justify-content-between align-items-center">
          <div className="d-flex gap-2 flex-wrap">
            {tabs.map((tab) => (
              <button
                key={tab.value}
                className={`btn ${activeTab === tab.value ? 'active' : ''}`}
                onClick={() => {
                  setActiveTab(tab.value);
                  setIsLoading(true);
                }}
              >
                {tab.label}
              </button>
            ))}
          </div>

          <div className="d-flex cme-10">
            <SeachInput
              placeholder="Search here"
              id="global_filter"
              value={globalSearchVal}
              onChange={handleGlobalSearch}
            />
          </div>
        </div>

        <div className="cps-20 cpe-20 ">
          <div className="d-flex justify-content-between align-items-center cpb-23 flex-wrap gap-2">
            <div className="title-text text-16-500-20">{abstractEventName}</div>
          </div>

          <Table
            isLoading={isLoading}
            header={header}
            rowData={rowData}
            filterData={filterData}
            // searchPayload={searchPayload}
            searchInputChange={handelChangeSearch}
            changeOffset={handelChangePagination}
            maxHeight="60vh"
          />
        </div>
      </Card>
    </div>
  );
};

export default ClientConferenceTickets;
